// testable helper functions for filtering operations

// count the number of occurrences of a field in a dataset
function countOccurrences(data, field) {
    console.log('data: ', data);
    console.log('field: ', field);
    let counts = {};
    data.forEach(item => {
        console.log('item: ', item[field]);
        if (counts[item[field]]) {
            counts[item[field]]++;
        } else {
            counts[item[field]] = 1;
        }
    });
    return counts;
}

// Get residue array from the carbuilder format using lexer
function getResidueArray(carbuilderFormat) {
    console.log('carbuilderFormat: ', carbuilderFormat);
    const lexChain = require('./visualizer-tool/glycan-interpreter/lexer').default;
    let residueArray = [];
    const lexChainArray = lexChain(carbuilderFormat);

    const getResidues = (array) => {
        const filteredArray = array.filter(item => item && (item.type === 'res' || item.type === 'brc'));
        filteredArray.forEach(item => {
            if (item.type === 'res') {
                residueArray.push(item.text || 'Unknown');
            } else if (item.type === 'brc') {
                getResidues(item.content);
            }
        });
    };
    getResidues(lexChainArray);
    return residueArray;
};

// map residues to their count in the array
function countResidues(residues) {
    return residues.reduce((acc, residue) => {
        acc[residue] = (acc[residue] || 0) + 1;
        return acc;
    }, {});
}

// remove residue from the array
function removeResidue(residue, array) {
    //remove first instance of that residue
    let index = array.indexOf(residue);
    if (index > -1) {
        let tempResidues = [...array];
        tempResidues.splice(index, 1);
        return tempResidues;
    }
    return array;
}

// add residue to the array
function addResidue(residue, array) {
    return([...array, residue]);
};

function normalizeLetter(letter, min = 60, max = 200) {
    const ascii = letter.toUpperCase().charCodeAt(0);
    const range = 90 - 65; // 'Z' - 'A'
    return Math.round(((ascii - 65) / range) * (max - min) + min);
}

function normalizeLength(length, min = 60, max = 200) {
    const clamped = Math.min(length, 15); // avoid long tail
    return Math.round(((clamped - 1) / (15 - 1)) * (max - min) + min);
}

function pastelize(r, g, b, weight = 0.8) {
    // Blend with white (255) to pastelize, but keep contrast
    const blend = (v) => Math.round(v * weight + 255 * (1 - weight));
    return `rgb(${blend(r)}, ${blend(g)}, ${blend(b)})`;
}


function colourMap(species) {
    if (species === 'Klebsiella pneumoniae') return '#D6C3F9';// '#E06F6F';
    if (species === 'Streptococcus pneumoniae') return '#81D2EE';
    if (species === 'Streptococcus suis') return '#FFB6C1';
    if (species === 'Escherichia coli') return '#9AD9BD'; //'#429C77';
    if (species === 'Shigella flexneri') return '#FFF4B2'; //'#FE990B';
    // Dynamic pastel color generation
    if (species) {
        const words = species.trim().split(' ');
        const firstWord = words[0] || '';
        const secondWord = words[1] || '';

        let r = normalizeLetter(firstWord.charAt(0) || 'A');
        let g = normalizeLetter(firstWord.charAt(1) || 'A');
        //let b = normalizeLetter(secondWord.charAt(0) || 'A');
        let b = normalizeLength(secondWord.length || 5);

        // Slightly bias toward a dominant channel for more colorfulness
       /* const maxChannel = Math.max(r, g, b);
        if (maxChannel === r) r += 10;
        else if (maxChannel === g) g += 10;
        else b += 10;*/

        return pastelize(r, g, b, 0.8); // lighter pastel mix
    }
    return  'white';
};

export default {countOccurrences, getResidueArray, countResidues, removeResidue, addResidue, colourMap};
